export const DEFAULT_IMAGE: string =
  "https://static.vecteezy.com/system/resources/previews/004/141/669/large_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg";

// export const DEFAULT_IMAGE: string ="https://cdn.discordapp.com/attachments/997264440858779729/1089041867468976208/336625909_660521739415829_829794385868510775_n.jpg";
